import { PropsWithChildren } from 'react';
import { RootStoreContext } from '../RootStoreContext';
import { RootStore, RootStoreHydrationData } from '../rootStore';

// local module level variable - holds singleton store
let store: RootStore;

// function to initialize the store
function initializeStore(hydrationData?: RootStoreHydrationData): RootStore {
    const _store = store ?? new RootStore(hydrationData?.session);

    // Hydrate the store once in the client
    if (_store?.hydrated === false && hydrationData) _store.hydrate(hydrationData);

    // Create the store once in the client
    if (!store) store = _store;

    return _store;
}

export function RootStoreProvider({
    children,
    hydrationData
}: PropsWithChildren<{ hydrationData: RootStoreHydrationData }>) {
    const store = initializeStore(hydrationData);

    return <RootStoreContext.Provider value={store}>{children}</RootStoreContext.Provider>;
}

// to able to use store out of the components
export default initializeStore();
